<template>
  <div class="site">
    <common-layout>
      <div slot="header">
        <h3>仪器服务</h3>
      </div>
      <div slot="container">
        <div class="base-search">
          <!-- 角色默认新增 -->
          <!-- <el-button @click="addDataNew" type="primary" v-if="isCollecting">新增</el-button> -->
          <el-button @click="addDataNew" type="primary">新增</el-button>
          <el-input
            placeholder="请输入内容"
            v-model="listQuery.keyword"
            class="input-with-select"
            @keyup.enter.native="search"
            clearable
            @clear="search"
            style="width: 240px"
          >
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>

          <el-select
            v-model="listQuery.serviceOrgStatus"
            placeholder="请选择审核状态"
            clearable
            style="display: block;width: 200px;"
            @change="searchSelect"
          >
            <el-option label="待审核" :value="1"></el-option>
            <el-option label="不通过" :value="2"></el-option>
            <el-option label="退回" :value="3"></el-option>
            <el-option label="通过" :value="4"></el-option>
          </el-select>
        </div>
        <div class="base-table">
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
            class="table"
          >
            <el-table-column
              type="index"
              :index="
                index => {
                  return index + (listQuery.page - 1) * listQuery.pageSize + 1;
                }
              "
              label="序号"
              align="center"
            ></el-table-column>
            <el-table-column
              label="仪器/服务名称"
              align="center"
              prop="equipmentName"
            ></el-table-column>
            <el-table-column
              label="机构名称"
              align="center"
              prop="serviceOrgName"
            ></el-table-column>
            <el-table-column label="服务领域" align="center" prop="serviceArea">
              <template slot-scope="{ row }">
                <div>{{ formatServiceArea(row.serviceArea) }}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="预约次数（次）"
              align="center"
              prop="applyNum"
            ></el-table-column>
            <el-table-column
              label="服务次数（次）"
              align="center"
              prop="serviceNum"
            ></el-table-column>
            <el-table-column
              label="服务成果（份）"
              align="center"
              prop="achievementNum"
            ></el-table-column>

            <el-table-column label="审核状态" align="center" prop="serviceOrgStatus">
              <template slot-scope="{ row }">
                <div v-if="row.serviceOrgStatus === 1">待审核</div>
                <div v-if="row.serviceOrgStatus === 2">不通过</div>
                <div v-if="row.serviceOrgStatus === 3">退回</div>
                <div v-if="row.serviceOrgStatus === 4">通过</div>
              </template>
            </el-table-column>

            <el-table-column width="240px" align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  class="mini_btn"
                  size="mini"
                  v-if="isLargeMarket || isCollecting"
                  type="danger"
                  @click="handleDetail(scope.$index, scope.row)"
                >
                  详情
                </el-button>

                <!-- 除了待审核，其他状态都可以删除 -->
                <el-button
                  class="mini_btn"
                  size="mini"
                  v-if="isCollecting && scope.row.serviceOrgStatus !== 1"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          layout="total, prev, pager, next,jumper"
          :total="total"
          :current-page.sync="listQuery.page"
          style="text-align:left;margin:20px 0"
          :page-size="listQuery.pageSize"
        ></el-pagination>
      </div>
    </common-layout>

    <el-dialog
      :visible.sync="dialogFormVisible"
      :title="Title"
      :close-on-click-modal="false"
      :append-to-body="true"
      @open="open"
    >
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="120px">
        <el-row>
          <el-form-item label="所属类别" prop="serviceType">
            <el-radio-group v-model="ruleForm.serviceType">
              <el-radio :label="1">仪器</el-radio>
              <el-radio :label="2">服务</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="服务机构" prop="serviceOrgName">
            <el-input
              v-model="ruleForm.serviceOrgName"
              placeholder="请输入机构名称"
              disabled
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item
            :label="ruleForm.serviceType === 1 ? '仪器名称' : '服务名称'"
            prop="equipmentName"
          >
            <el-input
              v-model="ruleForm.equipmentName"
              :placeholder="ruleForm.serviceType === 1 ? '请输入仪器名称' : '请输入服务名称'"
              :disabled="isDetail"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="使用费" prop="useFee">
            <el-input
              v-model="ruleForm.useFee"
              placeholder="请输入使用费"
              :disabled="isDetail"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="占用费" prop="occupancyFee">
            <el-input
              v-model="ruleForm.occupancyFee"
              placeholder="请输入占用费"
              :disabled="isDetail"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="支付方式" prop="paymentMethod">
            <el-select
              v-model="ruleForm.paymentMethod"
              placeholder="请选择支付方式"
              clearable
              style="display: block;"
              :disabled="isDetail"
            >
              <el-option
                :label="item.label"
                :value="item.id"
                v-for="item in paymentMethodList"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="服务时间" prop="serviceHours">
            <el-input
              v-model="ruleForm.serviceHours"
              placeholder="请输入服务时间"
              :disabled="isDetail"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="服务领域" prop="serviceArea">
            <el-select
              v-model="ruleForm.serviceArea"
              placeholder="请选择服务领域"
              clearable
              multiple
              style="display: block;"
              :disabled="isDetail"
            >
              <el-option
                :label="item.label"
                :value="item.value"
                v-for="item in innovationServiceAreaList"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="规格型号" prop="specifications">
            <el-input
              v-model="ruleForm.specifications"
              placeholder="请输入规格型号"
              :disabled="isDetail"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row v-if="ruleForm.serviceType === 1">
          <el-form-item label="仪器类别" prop="instrumentCategory">
            <el-select
              v-model="ruleForm.instrumentCategory"
              placeholder="请选择仪器类别"
              clearable
              style="display: block;"
              :disabled="isDetail"
            >
              <el-option
                :label="item.label"
                :value="item.id"
                v-for="item in instrumentCategoryList"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row v-if="ruleForm.serviceType === 2">
          <el-form-item label="服务类别" prop="serviceCategory">
            <el-select
              v-model="ruleForm.serviceCategory"
              placeholder="请选择服务类别"
              clearable
              style="display: block;"
              :disabled="isDetail"
            >
              <el-option
                :label="item.label"
                :value="item.id"
                v-for="item in serviceCategoryList"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="制造厂商" prop="manufacturers">
            <el-input
              v-model="ruleForm.manufacturers"
              placeholder="请输入制造厂商"
              :disabled="isDetail"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="生产国别" prop="productionCountry">
            <el-input
              v-model="ruleForm.productionCountry"
              placeholder="请输入生产国别"
              :disabled="isDetail"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="购置日期" prop="purchaseDate">
            <el-date-picker
              v-model="ruleForm.purchaseDate"
              type="date"
              placeholder="选择日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              clearable
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-row>

        <el-row>
          <el-form-item label="功能/应用范围" prop="applicationRange">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              placeholder="请输入功能/应用范围"
              v-model="ruleForm.applicationRange"
              :disabled="isDetail"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="主要技术指标" prop="mainSpecifications">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              placeholder="请输入主要技术指标"
              v-model="ruleForm.mainSpecifications"
              :disabled="isDetail"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="技术服务内容" prop="technicalServiceContent">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              placeholder="请输入技术服务内容"
              v-model="ruleForm.technicalServiceContent"
              :disabled="isDetail"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="服务内容" prop="serviceContent">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              placeholder="请输入服务内容"
              v-model="ruleForm.serviceContent"
              :disabled="isDetail"
            ></el-input>
          </el-form-item>
        </el-row>

        <el-row>
          <el-form-item label="仪器图片" prop="instrumentPicture">
            <el-upload
              class="avatar-uploader"
              :action="this.uploadURL"
              list-type="picture-card"
              name="file"
              :file-list="instrumentPicture"
              :before-upload="beforeAvatarUpload"
              :disabled="isDetail"
              :limit="limit"
              ref="upload0"
              :on-success="
                (response, file, fileList) =>
                  handleAvatarSuccess(response, file, fileList, 'instrumentPicture')
              "
            >
              <i slot="default" class="el-icon-plus"></i>
              <div slot="file" slot-scope="{ file }">
                <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-preview"
                    @click="handlePictureCardPreview(file)"
                  >
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span
                    v-if="!isDetail"
                    class="el-upload-list__item-delete"
                    @click="handleRemove(file, 'instrumentPicture')"
                  >
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
              <div slot="tip" class="el-upload__tip" v-if="showUpload1 && !isDetail">
                只允许上传一张图片
              </div>
            </el-upload>
          </el-form-item>
        </el-row>

        <el-row>
          <el-form-item label="是否发布" prop="publishedFlag" style="text-align:left">
            <el-switch
              v-model="ruleForm.publishedFlag"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="是"
              inactive-text="否"
              :active-value="1"
              :inactive-value="0"
              :disabled="isDetail"
            ></el-switch>
          </el-form-item>
        </el-row>
        <div class="form-title" v-if="dialogType === 'detail'">审核信息</div>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="审批状态"
              prop="serviceOrgStatus"
              style="text-align:left"
              v-if="dialogType === 'detail'"
            >
              <el-select
                v-model="ruleForm.serviceOrgStatus"
                placeholder="请选择审核状态"
                style="display: block;"
                :disabled="isDetail || isCollecting"
              >
                <el-option label="待审核" :value="1"></el-option>
                <el-option label="不通过" :value="2"></el-option>
                <el-option label="退回" :value="3"></el-option>
                <el-option label="通过" :value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="审核意见" prop="auditOpinion" v-if="dialogType === 'detail'">
              <el-input
                v-model="ruleForm.auditOpinion"
                placeholder="请填写审核意见"
                :disabled="isDetail"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="附件上传" prop="file" v-if="dialogType === 'detail'">
          <el-upload
            class="upload-demo"
            :action="this.uploadURL"
            style="text-align: left;"
            :disabled="isDetail"
            :before-upload="beforeFileUploadLimit"
            :on-remove="(file, fileList) => handleFileRemove(file, fileList, 'file')"
            :file-list="file"
            :on-success="
              (response, file, fileList) => handleFileSuccess(response, file, fileList, 'file')
            "
            list-type="picture"
          >
            <el-button size="small" type="primary" :disabled="isDetail">
              上传附件材料
            </el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editOperate" v-if="dialogType !== 'add'">
          修 改
        </el-button>
        <el-button type="primary" @click="createSite" v-if="dialogType === 'add'">确 定</el-button>
        <el-button @click="dialogFormVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import CommonLayout from '../../../components/common-layout.vue';
export default {
  components: {
    CommonLayout
  },
  data() {
    return {
      Title: '',
      // 1待审核, 2不通过, 3退回, 4通过
      serviceOrgStatus: '',
      formApprovalStatus: '',
      listQuery: {
        keyword: '',
        is_page: 0,
        page: 1,
        pageSize: 10,
        serviceType: 1,
        serviceOrgStatus: 1
      },
      paymentMethodList: [
        { id: 1, label: '线上创新券支付' },
        { id: 2, label: '线下人民币支付' },
        { id: 3, label: '两种支付方式并行' }
      ],
      serviceTypeList: [
        {
          label: '检测检验',
          id: 1
        },
        {
          label: '委托开发',
          id: 2
        },
        {
          label: '专利申请代理',
          id: 3
        },
        {
          label: '技术转移',
          id: 4
        }
      ],
      dialogVisible: false,
      dialogFormVisible: false,
      dialogType: '',
      dialogImageUrl: '',
      instrumentPicture: [],
      file: [],

      is_edit: false,
      headerStyle: {
        color: '#623AA2',
        background: '#E5F3FE'
      },
      innovationServiceAreaList: [],
      instrumentCategoryList: [
        { id: 1, label: '分析仪器' },
        { id: 2, label: '计量仪器' },
        { id: 3, label: '电子测量仪器' },
        { id: 4, label: '天文仪器' },
        { id: 5, label: '核仪器' },
        { id: 6, label: '其他仪器' }
      ],
      serviceCategoryList: [
        { id: 1, label: '企业研发' },
        { id: 2, label: '样品采集' }
      ],
      number: 0,
      operationType: 'add',
      per_page: 10,
      total: 20,
      ruleForm: this.resetData(),
      rules: {
        serviceType: [{ required: true, message: '请选择所属类别', trigger: 'blur' }],
        serviceOrgName: [{ required: true, message: '请输入服务机构', trigger: 'blur' }],
        equipmentName: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        useFee: [{ required: true, message: '请输入使用费', trigger: 'change' }],
        occupancyFee: [{ required: true, message: '请输入占用费', trigger: 'change' }],
        paymentMethod: [{ required: true, message: '请选择支付方式', trigger: 'change' }],
        serviceHours: [{ required: true, message: '请输入服务时间', trigger: 'change' }],
        serviceArea: [{ required: true, message: '请选择服务领域', trigger: 'change' }],
        specifications: [{ required: true, message: '请输入规格型号', trigger: 'change' }],
        instrumentCategory: [{ required: true, message: '请选择仪器类别', trigger: 'change' }],
        serviceCategory: [{ required: true, message: '请选择服务类别', trigger: 'change' }],
        manufacturers: [{ required: true, message: '请输入制造厂商', trigger: 'blur' }],
        productionCountry: [{ required: true, message: '请输入生产国别', trigger: 'blur' }],
        purchaseDate: [{ required: true, message: '请选择购置日期', trigger: 'blur' }],
        applicationRange: [{ required: true, message: '请输入功能应用范围', trigger: 'blur' }],
        mainSpecifications: [{ required: true, message: '请输入主要技术指标', trigger: 'blur' }],
        technicalServiceContent: [
          { required: true, message: '请输入技术服务内容', trigger: 'blur' }
        ],
        serviceContent: [{ required: true, message: '请输入服务内容', trigger: 'blur' }],
        instrumentPicture: [
          { required: true, message: '请上传仪器图片', trigger: ['blur', 'change'] }
        ],

        publishedFlag: [{ required: true, message: '请选择是否发布', trigger: ['blur', 'change'] }],
        serviceOrgStatus: [
          { required: true, message: '请选择审批状态', trigger: ['blur', 'change'] }
        ]
      },
      tableData: [],
      limit: 1,
      showUpload1: false,
      showUpload2: false
    };
  },
  computed: {
    isDetail() {
      return this.dialogType === 'detail' && this.formApprovalStatus === 4;
    }
  },
  created() {
    this.getGroup();
    this.getData();
    this.getByUser();
  },
  watch: {
    // 监听初始时图片列表长度, 与limit相等则隐藏按钮
    instrumentPicture: {
      handler() {
        this.checkLimit(this.instrumentPicture, 0);
      }
    }
  },
  methods: {
    beforeFileUploadLimit(file) {
      if (this.file.length === 1) {
        return this.$message.warning('您已经上传了一份附件，请删除后重新上传');
      }
      const isLt2M = file.size / 1024 / 1024 < 100;
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 100MB!');
      }
      return isLt2M;
    },
    handleFileRemove(file, fileList, type) {
      this.file = fileList;
      this.fileListChange(type);
      // if (fileList.length === 0) {
      //   this.ruleForm.file = '';
      // } else {
      //   this.ruleForm.file = JSON.stringify(fileList);
      // }
    },
    handleFileSuccess(response, file, fileList, type) {
      if (response.code == 0) {
        this.file = fileList;
        this.fileListChange(type);
      }
    },
    //搜索
    search() {
      this.listQuery.page = 1;
      this.getData();
    },
    async open() {
      if (this.dialogType === 'add') {
        this.resetData();
        this.$nextTick(() => {
          this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
        });
      } else if (this.dialogType === 'edit' || this.dialogType === 'detail') {
        await this.getDetail();
      }
    },
    async getDetail() {
      try {
        const res = await this.http.get(
          `${this.urlConfig.devUrl}apij2/admin-api/innovation/instrument/get?id=${this.queryId}`
        );
        console.log(res, 'res');
        if (res.code === 0) {
          this.ruleForm = Object.assign(this.ruleForm, res.data);
          this.ruleForm.serviceArea = this.ruleForm?.serviceArea?.split(',');
          this.instrumentPicture = res.data.instrumentPicture
            ? JSON.parse(res.data.instrumentPicture)
            : [];
          this.file = res.data.file ? JSON.parse(res.data.file) : [];
        } else {
          this.resetData();
        }
      } catch (e) {
        console.log(e);
      }
    },
    getByUser() {
      this.http
        .post(this.urlConfig.devUrl + 'apij2/admin-api/innovation/introduction/getByUser')
        .then(res => {
          if (res.code === 0) {
            this.serviceOrgId = res.data.id;
            this.serviceOrgName = res.data.name;
            this.ruleForm.serviceOrgId = res.data.id;
            this.ruleForm.serviceOrgName = res.data.name;
          }
        });
    },
    getData() {
      if (this.listQuery.serviceOrgStatus === null) {
        this.$delete(this.listQuery, 'serviceOrgStatus');
      }
      this.http
        .post(this.urlConfig.devUrl + 'apij2/admin-api/innovation/instrument/page', this.listQuery)
        .then(res => {
          if (res.code == 0) {
            let arr = res.data.data;
            arr.forEach(item => {
              if (item.instrumentPicture) {
                item.imgSrc = JSON.parse(item.instrumentPicture)[0].url;
              } else {
                item.imgSrc = '';
              }
            });
            this.tableData = arr;
            // this.tableData = res.data.data;
            this.total = res.data.total;
          }
        });
    },
    //选择页码
    handleCurrentChange(e) {
      this.listQuery.page = e;
      this.getData();
    },
    // 获取数据字典
    getGroup(row) {
      let obj = {
        dictTypes: ['innovation_service_area']
      };
      this.http.post(`${urlConfig.devUrl}apij2/admin-api/system/dict-data/getGroup`, obj).then(
        response => {
          if (response.code === 0) {
            this.innovationServiceAreaList = response.data.innovation_service_area;
          } else {
            this.$message.error(response.status);
          }
        },
        error => {}
      );
    },
    checkLimit(filelist, index) {
      const limit = this.limit;
      console.log(this.$refs['upload' + index]);
      const uploadDom = this.$refs['upload' + index];
      if (uploadDom) {
        if (filelist.length === limit) {
          uploadDom.$children[1].$el.style.display = 'none';
          this['showUpload' + (index + 1)] = true;
        } else {
          uploadDom.$children[1].$el.style.display = '';
          this['showUpload' + (index + 1)] = false;
        }
      }
    },
    selectChange(e, list, props) {
      if (e) {
        this.ruleForm[props] = list.find(item => item.id === e).label;
      } else {
        this.ruleForm[props] = '';
      }
      console.log('this.ruleForm[props]', this.ruleForm[props]);
    },
    // 修改按钮操作
    editOperate() {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          this.ruleForm.serviceArea = this.ruleForm.serviceArea.toString();
          this.http
            .post(`${urlConfig.devUrl}apij2/admin-api/innovation/instrument/update`, this.ruleForm)
            .then(res => {
              if (res.code == 0) {
                this.$message.success('编辑成功');
                this.dialogFormVisible = false;

                this.resetData();
                this.getData();
              } else {
                this.$message.error(res.status);
              }
            })
            .catch(err => {
              this.dialogFormVisible = false;
            });
        } else {
          this.is_edit = true;

          console.log('error submit!!');
          return false;
        }
      });
    },
    searchSelect(e) {
      if (e) {
        this.listQuery.serviceOrgStatus = e;
        this.getData();
      } else {
        this.$delete(this.listQuery, 'serviceOrgStatus');
        this.getData();
      }
    },
    resetData() {
      return (this.ruleForm = {
        serviceType: 1, // 所属类别
        serviceOrgName: this.serviceOrgName, // 服务机构名称
        serviceOrgId: this.serviceOrgId, // 服务机构名称
        equipmentName: null, // 仪器名称-服务名称
        useFee: null, // 使用费
        occupancyFee: null, // 占用费
        paymentMethod: null, // 支付方式
        serviceHours: null, // 服务时间
        serviceArea: null, // 服务领域
        specifications: null, // 规格型号
        instrumentCategory: null, // 仪器类别
        serviceCategory: null, // 服务类别
        manufacturers: null, // 制造厂商
        productionCountry: null, // 生产国别
        purchaseDate: null, // 购置日期
        applicationRange: null, // 功能应用范围
        mainSpecifications: null, // 主要技术指标
        technicalServiceContent: null, // 技术服务内容
        serviceContent: null, // 服务内容
        instrumentPicture: null, // 仪器图片
        publishedFlag: 0, // 是否发布
        serviceOrgStatus: null, // 审核状态
        file: '', // 附件
        auditOpinion: '' // 审核意见
      });
    },

    //城市选择
    citySelected(e) {
      if (e.province.value) {
        this.ruleForm.orgProvince = e.province.value;
      }
      if (e.city.value) {
        this.ruleForm.orgCity = e.city.value;
      }
      if (e.area.value) {
        this.ruleForm.orgDistrict = e.area.value;
      }
    },
    deleteImg(type) {
      this.$confirm('确定删除图片吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          this.fileListChange(type, []);
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    handleDelete(index, row) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          this.http
            .delete(`${urlConfig.devUrl}apij2/admin-api/innovation/instrument/delete?id=${row.id}`)
            .then(res => {
              if (res.code === 0) {
                this.resetData();
                this.getData();
                this.$message({
                  type: 'success',
                  message: '删除成功'
                });
              } else {
                this.$message({
                  message: '失败！',
                  type: 'error'
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDetail(index, row) {
      this.dialogFormVisible = true;
      this.Title = '详情';
      this.dialogType = 'detail';
      this.queryId = row.id;
      this.formApprovalStatus = row.serviceOrgStatus;
    },
    addDataNew() {
      this.dialogFormVisible = true;
      this.Title = '新增';
      this.dialogType = 'add';
      this.instrumentPicture = [];
      this.file = [];
    },
    // 确认添加机构
    createSite() {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          this.ruleForm.serviceArea = this.ruleForm.serviceArea.toString();
          this.http
            .post(`${urlConfig.devUrl}apij2/admin-api/innovation/instrument/create`, this.ruleForm)
            .then(res => {
              if (res.code == 0) {
                this.$message.success('新增成功');
                this.dialogFormVisible = false;
                this.resetData();
                this.getData();
              } else {
                this.$message.error(res.status);
              }
            })
            .catch(err => {
              this.dialogFormVisible = false;
            });
        } else {
          this.is_edit = true;

          console.log('error submit!!');
          return false;
        }
      });
    },
    handleRemove(file, type) {
      this.$confirm('确定删除图片吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          for (var i = 0; i < this[type].length; i++) {
            if (file.uid == this[type][i].uid) {
              this[type].splice(i, 1);
            }
          }
          console.log(this[type]);
          this.fileListChange(type);

          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    handleAvatarSuccess(response, file, fileList, type) {
      if (response.code == 0) {
        this[type] = fileList;
        this.fileListChange(type);
      }
    },
    fileListChange(type) {
      let arr = [];
      if (this[type].length > 0) {
        this[type].map(item => {
          arr.push({
            url: item.size ? this.imgUrl + item.response.data.store_result : item.url,
            name: item.name
          });
        });
        this.ruleForm[type] = JSON.stringify(arr);

        // if (type === 'logoSrc' || type === 'realImageSrc') {
        //   this.ruleForm[type] = arr[0].url;
        // }
      } else {
        this.ruleForm[type] = '';
        this[type] = [];
      }
    },
    formatServiceArea(val) {
      const arr = val && val.split(',');
      let result = '';
      arr &&
        arr.map(item => {
          const { label } = this.innovationServiceAreaList.find(
            el => Number(el.value) === Number(item)
          );
          label && (result += label + ',');
        });
      return result && result.substring(0, result.length - 1);
    },
    beforeAvatarUpload(file) {
      let type = false;
      if (
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg' ||
        file.type === 'image/gif' ||
        file.type === 'image/bmp'
      ) {
        type = true;
      }

      var img = new Image();
      img.src = this.image;
      img.onload = function() {};

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error('上传图片只能是 JPEG/jpg/png/gif/bmp 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 10MB!');
      }
      return type && isLt2M;
    }
  }
};
</script>
<style lang="scss">
@include component(site) {
  width: 100%;
  height: 100%;

  @include part(header) {
    display: flex;
    justify-content: flex-start;

    @include component(el-input) {
      width: 300px;
    }
  }

  .base-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    /deep/.el-input--suffix {
      width: 100%;
      margin: 0 15px;
    }
    .el-input {
      // width: 400px;
      margin: 0 15px;
    }
    .date-picker {
      margin: 0 15px;
      .el-range-separator {
        width: auto;
      }
    }
  }
  .base-table {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #eef1f6;
  }

  .el-select {
    width: 100%;
    margin: 0;
  }

  @include part(form) {
    margin: 30px auto;
    width: 50%;
  }

  @include component(rowItem) {
    width: 50%;
  }

  @include component(el-radio-group) {
    width: 100%;
    text-align: left;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .preview_btn {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: rgba(#000, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    i {
      cursor: pointer;
      font-size: 26px;
    }
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 130px;
    line-height: 130px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .el-radio-group {
    display: flex;
  }

  .upload_btn {
    display: block;
    background-color: #00a1ff;
    font-weight: bold;
    color: #fff;
    padding: 2px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  .upload_btn:hover {
    background-color: #13ce66;
  }

  .del_img {
    position: absolute;
    top: -7px;
    left: 224px;
    color: #00a1ff;
  }

  .del_img:hover {
    cursor: pointer;
    color: #f00;
  }

  .del_img i:before {
    font-size: 20px;
  }
  .img_border {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    width: 243px;
    height: 154px;
    display: block;
  }

  .el-radio {
    display: flex;
    align-items: center;
  }

  .imgInput {
    background: url(../../../assets/add.png) no-repeat;
    border: none;
    text-indent: -2000px;
    height: 120px;
    padding: 10px;
    background-size: 70%;
    background-position: center;
    color: white;
    cursor: pointer;
  }

  .imgInput:focus {
    border: none;
    outline: 0;
  }

  .allPics {
    border: 1px solid #ccc;
    padding: 18px 15px 10px 20px;
    width: 90%;
    margin: 0 auto;
    margin-bottom: 30px;
    position: relative;
    // display: flex;
    // flex-wrap: wrap;
    // justify-content: space-between;
  }

  .allPics1 {
    display: flex;
    // flex-wrap: wrap;
  }

  .addPic-body {
    padding: 10px;
    height: 120px;
  }

  .addPic-close {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .addPic {
    max-width: 100%;
    max-height: 100%;
  }

  .el-form-item__content {
    text-align: left;
  }

  .form-title {
    width: 100%;
    text-align: left;
    color: #623aa2;
    border-left: 5px solid #623aa2;
    border-bottom: 1px solid #623aa2;
    padding-left: 10px;
    font-size: 20px;
    margin-bottom: 20px;
    font-weight: 700;
  }

  .rowItem1 {
    float: left;
  }
}
</style>
